import LeftPartStyles from 'src/components/leftPart/LeftPartStyles';
import ListItemsIcon from 'src/assets/icons/ListItemsIcon';
import TelegramIcon from 'src/assets/icons/TelegramIcon';
import CustomInView from 'src/components/ui/other/customInView/CustomInView';
import { useMemo } from 'react';

const listItems = ['Camera fines delivered to your Telegram', 'Car insurance and M.O.T. status', 'Road tax status', 'Completely free, no hidden fees'];

function LeftPart() {
  const link = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const sanitize = (value: string | null) => (value ? value.replace(/[^a-zA-Zа-яА-Я0-9]/g, '') : '');

    const utmCampaign = sanitize(searchParams.get('utm_campaign'));
    const utmMedium = sanitize(searchParams.get('utm_medium'));
    const utmSource = sanitize(searchParams.get('utm_source'));

    return `https://t.me/cy_camfines_bot?start=ref-website${utmSource ? `_utmSource-${utmSource}` : ''}${utmCampaign ? `_utmCampaign-${utmCampaign}` : ''}${utmMedium ? `_utmMedium-${utmMedium}` : ''}`;
  }, []);

  return (
    <LeftPartStyles>
      <CustomInView as="div" classes="logoWrapper">
        <img src="/images/logo.png" alt="Logo" />

        <h2 className="titleFont">CY CamFines Bot</h2>
      </CustomInView>

      <div className="mainContent">
        <CustomInView as="h1" classes="titleFont">Realtime notifications for traffic violations caught on camera in Cyprus</CustomInView>

        <ul>
          {listItems.map((text, index) => (
            <CustomInView as="li" key={text}>
              <ListItemsIcon extraStyles={{ transitionDelay: `${index * 0.1}s` }} />
              <span style={{ transitionDelay: `${index * 0.1 + 0.2}s` }}>
                {text}
              </span>
            </CustomInView>
          ))}
        </ul>
      </div>

      <CustomInView classes="buttonWrapper">
        <a
          className="button"
          href={link}
        >
          <TelegramIcon />

          Go to Telegram bot
        </a>
      </CustomInView>
    </LeftPartStyles>
  );
}

export default LeftPart;
